export default __webpack_public_path__ + "static/media/grenadier.ff41d945.svg";